import React from 'react';
import { ItemIcon, DefaultName } from '../../styles';

const ItemElement = ({ item }) => {
  return (
    <ItemIcon hide={!item?.flag}>
      {item?.flag || <DefaultName>{item?.name?.slice(0, 2)}</DefaultName>}
    </ItemIcon>
  );
};

export default ItemElement;
